import OrchestratorAPI from '../common';
import {
  CreateValues,
  PracticeConfigEhrInstance,
  UpdateValues,
  FindAllOptions,
} from '../../models/orchestrator/practiceConfig/ehrInstance';

export default class API extends OrchestratorAPI {
  protected readonly API_PATH = '/practice-config-ehr-instances';

  async findAll(
    options: FindAllOptions = {},
  ): Promise<PracticeConfigEhrInstance[]> {
    const url = this.constructPath('/', options);
    const { practiceConfigEhrInstances } = await this.common.getJSON(url);
    return practiceConfigEhrInstances.map(this.deserialize);
  }

  async findOneById(id: string): Promise<PracticeConfigEhrInstance> {
    const url = this.constructPath(`/${id}`);
    const { practiceConfigEhrInstance } = await this.common.getJSON(url);
    return this.deserialize(practiceConfigEhrInstance);
  }

  async create(values: CreateValues): Promise<PracticeConfigEhrInstance> {
    const url = this.constructPath('/');
    const { practiceConfigEhrInstance } = await this.common.postJSON(
      url,
      values,
    );
    return this.deserialize(practiceConfigEhrInstance);
  }

  async remove(id: string): Promise<void> {
    const url = this.constructPath(`/${id}`);
    return this.common.deleteJSON(url);
  }

  async update(
    id: string,
    values: UpdateValues,
  ): Promise<PracticeConfigEhrInstance> {
    const url = this.constructPath(`/${id}`);
    const { practiceConfigEhrInstance } = await this.common.patchJSON(
      url,
      values,
    );
    return this.deserialize(practiceConfigEhrInstance);
  }
}
